import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';

import * as S from './Collapsible.styles';

export const Collapsible = ({ trigger, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <CollapsiblePrimitive.Root open={open} onOpenChange={setOpen}>
      <S.Trigger asChild>
        <span>
          {trigger}
          <FontAwesomeIcon icon={faChevronDown as Icon} />
        </span>
      </S.Trigger>
      <CollapsiblePrimitive.Content>{children}</CollapsiblePrimitive.Content>
    </CollapsiblePrimitive.Root>
  );
};

export default Collapsible;
